import BitacoraAPI from "@/services/bitacoras/bitacora";
import store from "@/store";
import {HTTP} from "@/helpers/http-common";
/**
 * Defines the vuejs plugin
 * 
 * @param {object} Vue The Vue instance
 * @param {object} rt The Router instance
 */
function plugin (Vue, rt) {
  if (!rt)
    throw new Error("You must supply a Router Vue instance...");
    
  /**
   * Calls the api to save the binnacle
   * 
   * @param {string} The name of the view to save the binnacle
   */
  const callBitacora = (bitacora, path)=> new Promise((resolve, reject)=>{
    // console.log(bitacora)
    BitacoraAPI.record({entidad:bitacora, ruta:path})
    .then(response=>resolve(response))
    .catch(error=>reject(error));  
  })

  /**
   * Calls the fos api to save info about when a user enters to a view
   * 
   * @param {object} to The target Route Object being navigated to
   * @param {object} from The current route being navigated away from
   */
  function bitacora(to, from){
    if(((to || {}).meta || {}).bitacora &&store.getters.getUserIsAuthenticated){
      //Add Authorization header if it isnt set, this occurrs after a refresh action
      if(!HTTP.defaults.headers.common['Authorization'])
        HTTP.defaults.headers.common['Authorization'] = `Bearer ${store.getters.getUserToken}`;
      //Calling Bitacora
      callBitacora(to.meta.bitacora || "", to.path);
    }
  }

  //Adding function to after each router method
  rt.afterEach(bitacora);
  Vue.prototype.$bitacora = callBitacora;
}



plugin.version = "__VERSION__";

export default plugin;

if (typeof window !== "undefined" && window.Vue) {
  window.Vue.use(plugin);
}


// WEBPACK FOOTER //
// ./src/plugins/bitacora/index.js